import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faBars } from '@fortawesome/free-solid-svg-icons';
import '../Navigation.css'; // Import the CSS file

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('header'); // Define the activeSection state
  const navRef = useRef(null);

  const handleClickOutside = (event) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMenuClick = (event, targetId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const scrollMarginTop = 112; // 7rem in pixels (7 * 16 = 112)
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - scrollMarginTop;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });

      setActiveSection(targetId); // Update the activeSection state
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="nav-container" ref={navRef}>
      <a href="#header" className="nav-logo" aria-label="Go to home page">
        <FontAwesomeIcon className="home-icon" icon={faHouse} size="2x" />
      </a>
      <nav>
        <ul className={`nav-links ${isMenuOpen ? 'show' : ''}`}>
          <li className="transition-all duration-250 hover:text-red-400 hover:-translate-y-1 hover:-translate-x-1">
            <a href="#header" aria-label="Go to Home page" className={activeSection === 'header' ? 'active' : ''} onClick={(e) => handleMenuClick(e, 'header')}>Home</a>
          </li>
          <li className="transition-all duration-250 hover:text-red-400 hover:-translate-y-1 hover:-translate-x-1">
            <a href="#about" aria-label="Go to About Me page" className={activeSection === 'about' ? 'active' : ''} onClick={(e) => handleMenuClick(e, 'about')}>About Me</a>
          </li>
          <li className="transition-all duration-250 hover:text-red-400 hover:-translate-y-1 hover:-translate-x-1">
            <a href="#languages" aria-label="Go to Languages page" className={activeSection === 'languages' ? 'active' : ''} onClick={(e) => handleMenuClick(e, 'languages')}>Languages</a>
          </li>
          <li className="transition-all duration-250 hover:text-red-400 hover:-translate-y-1 hover:-translate-x-1">
            <a href="#experience" aria-label="Go to Experience page" className={activeSection === 'experience' ? 'active' : ''} onClick={(e) => handleMenuClick(e, 'experience')}>Experience</a>
          </li>
          <li className="transition-all duration-250 hover:text-red-400 hover:-translate-y-1 hover:-translate-x-1">
            <a href="#skills" aria-label="Go to Skills page" className={activeSection === 'skills' ? 'active' : ''} onClick={(e) => handleMenuClick(e, 'skills')}>Skills</a>
          </li>
          <li className="transition-all duration-250 hover:text-red-400 hover:-translate-y-1 hover:-translate-x-1">
            <a href="#certifications" aria-label="Go to Certifications page" className={activeSection === 'certifications' ? 'active' : ''} onClick={(e) => handleMenuClick(e, 'certifications')}>Certifications</a>
          </li>
          <li className="transition-all duration-250 hover:text-red-400 hover:-translate-y-1 hover:-translate-x-1">
            <a href="#projects" aria-label="Go to Projects page" className={activeSection === 'projects' ? 'active' : ''} onClick={(e) => handleMenuClick(e, 'projects')}>Hobbies</a>
          </li>
          <li className="transition-all duration-250 hover:text-red-400 hover:-translate-y-1 hover:-translate-x-1">
            <a href="#contact" aria-label="Go to Contact page" className={activeSection === 'contact' ? 'active' : ''} onClick={(e) => handleMenuClick(e, 'contact')}>Contact</a>
          </li>
          <li className="transition-all duration-250 hover:text-red-400 hover:-translate-y-1 hover:-translate-x-1">
            <a href="/cv/AntiaAlamanMartinezCV.pdf" target="_blank" download aria-label="Download my cv" className="nav-cv" onClick={() => setIsMenuOpen(false)}>CV</a>
          </li>
        </ul>
        <div className="nav-hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <FontAwesomeIcon icon={faBars} className="bars-icon" size="2x" />
        </div>
      </nav>
    </header>
  );
}

export default Navigation;